"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClickAway = void 0;
var hooks_1 = require("evt/hooks");
var evt_1 = require("evt");
var useConstCallback_1 = require("./useConstCallback");
var useStateRef_1 = require("./useStateRef");
function useClickAway(params) {
    var _a;
    var onClickAway = params.onClickAway;
    var internallyCreatedRef = (0, useStateRef_1.useStateRef)(null);
    var ref = (_a = params === null || params === void 0 ? void 0 : params.ref) !== null && _a !== void 0 ? _a : internallyCreatedRef;
    var onClickAway_const = (0, useConstCallback_1.useConstCallback)(onClickAway);
    (0, hooks_1.useEvt)(function (ctx) {
        return evt_1.Evt.from(ctx, document, "mousedown")
            .attach(function (_a) {
            var _b;
            var target = _a.target;
            return !((_b = ref.current) === null || _b === void 0 ? void 0 : _b.contains(target));
        }, onClickAway_const);
    }, []);
    return { ref: ref };
}
exports.useClickAway = useClickAway;
//# sourceMappingURL=useClickAway.js.map